import { FieldType } from "@/enums";
import { bool, object, string } from "prop-types";
import { DynamicUpload } from "./components";
import { DynamicAutoComplete } from "./DynamicAutoComplete";
import { DynamicCheckbox } from "./DynamicCheckbox";
import { DynamicDatePicker } from "./DynamicDatePicker";
import { DynamicDateRangePicker } from "./DynamicDateRangePicker";
import { DynamicDropDown } from "./DynamicDropDown";
import { DynamicInput } from "./DynamicInput";
import { DynamicInputNumber } from "./DynamicInputNumber";
import { DynamicMentions } from "./DynamicMentions";
import { DynamicPercentCompleteSlider } from "./DynamicPercentCompleteSlider";
import { DynamicSwitch } from "./DynamicSwitch";
import { DynamicTextArea } from "./DynamicTextArea";

const DynamicFormField = ({ formField, formDisabled, placeholderId }) => {
  const {
    property: { name, fieldType },
  } = formField;
  const sharedAttributes = {
    formField,
    formDisabled,
    placeholderId,
  };

  switch (fieldType) {
    case FieldType.TextArea:
      return <DynamicTextArea key={name} {...sharedAttributes} />;
    case FieldType.DropDown:
    case FieldType.MultiSelectDropDown:
      return <DynamicDropDown key={name} {...sharedAttributes} />;
    case FieldType.AutoComplete:
    case FieldType.MultiSelectAutoComplete:
      return <DynamicAutoComplete key={name} {...sharedAttributes} />;
    case FieldType.Date:
      return <DynamicDatePicker key={name} {...sharedAttributes} />;
    case FieldType.DateRange:
      return <DynamicDateRangePicker key={name} {...sharedAttributes} />;
    case FieldType.Number:
      return <DynamicInputNumber key={name} {...sharedAttributes} />;
    case FieldType.Checkbox:
      return <DynamicCheckbox key={name} {...sharedAttributes} />;
    case FieldType.PercentCompleteSlider:
      return <DynamicPercentCompleteSlider key={name} {...sharedAttributes} />;
    case FieldType.Attachment:
    case FieldType.MultiAttachment:
      return <DynamicUpload key={name} {...sharedAttributes} />;
    case FieldType.TextAreaWithMentions:
      return <DynamicMentions key={name} {...sharedAttributes} />;
    case FieldType.Switch:
      return <DynamicSwitch key={name} {...sharedAttributes} />;
    case FieldType.Text:
    default:
      return <DynamicInput key={name} {...sharedAttributes} />;
  }
};

DynamicFormField.propTypes = {
  formField: object.isRequired,
  formDisabled: bool,
  placeholderId: string,
};

export default DynamicFormField;
